export default {"src":"/_next/static/media/OUT.57bbc258.svg","height":18,"width":18};